/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {ImmortalFruitsFontConfig} from "./ImmortalFruitsFontConfig";
import {ImmortalFruitsGameAssets} from "./ImmortalFruitsGameAssets";
import {ImmortalFruitsGameConfig} from "./ImmortalFruitsGameConfig";
import {ImmortalFruitsSoundConfig} from "./ImmortalFruitsSoundConfig";
import {ImmortalFruitsServerDataParser} from "./server/ImmortalFruitsServerDataParser";
import {ImmortalFruitsParsedGameData} from "./server/data/ImmortalFruitsParsedGameData";
import {ImmortalFruitsParsedInitData} from "./server/data/ImmortalFruitsParsedInitData";
import {ImmortalFruitsReelSymbol} from "./symbols/ImmortalFruitsReelSymbol";
import {ImmortalFruitsReelSymbolStateCreator} from "./symbols/ImmortalFruitsReelSymbolStateCreator";
import {Jackpot} from "./jackpot/jackpot";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {ImmortalFruitsZeroBetController} from "./zerobet/ImmortalFruitsZeroBetController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {ImmortalFruitsReelController} from "./reel/ImmortalFruitsReelController";
import {WinTextView} from "./views/WinTextView";
import {CountUpView} from "./views/CountUpView";
import {ImmortalFruitsSymbolsWinAnimations} from "./winAnimations/symbols/ImmortalFruitsSymbolsWinAnimations";
import {SpinStart} from "./gameround/spin/SpinStart";
import {ReelStart} from "./gameround/reel/ReelStart";
import {ReelStop} from "./gameround/reel/ReelStop";
import {SpinStop} from "./gameround/spin/SpinStop";
import {NormalWin} from "./gameround/normalWin/NormalWin";
import {InitialWin} from "./gameround/initialWin/InitialWin";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {WinEnd} from "./gameround/winEnd/WinEnd";
import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {ImmortalFruitsBetLineWin} from "./gameround/betLineWin/ImmortalFruitsBetLineWin";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ImmortalFruitsGameMode} from "./ImmortalFruitsGameMode";
import {ImmortalFruitsLayerConfig} from "./config/IImmortalFruitsLayerConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {bonusWheelController} from "./gameround/bonusWheelController";
import {ImmortalFruitsbonusViewIntroView} from "./transitions/ImmortalFruitsbonusViewIntroView";
import {ImmortalFruitsWinPresentation} from "./gameround/ImmortalFruitsWinPresentation";
import {ImmortalFruitsbonusViewOutroView} from "./transitions/ImmortalFruitsbonusViewOutroView";
import {ImmortalFruitsReelBackgroundView} from "./reelBackground/ImmortalFruitsReelBackgroundView";
import {ImmortalFruitsStoppablePresentation} from "./gameround/ImmortalFruitsStoppablePresentation";
import {ImmortalFruitsPolyBetLine} from "./betline/line/ImmortalFruitsPolyBetLine";
import {ImmortalFruitsNearWin} from "./gameround/nearWin/ImmortalFruitsNearWin";
import {ImmortalFruitsBackground} from "./background/ImmortalFruitsBackground";
import {ImmortalIdleAnimationController} from "./idleAnimation/reelBackgroundIdleAnimation/ImmortalIdleAnimationController";
import {ImmortalFruitsSpinReelPartAnimator} from "./reel/spinReel/ImmortalFruitsSpinReelPartAnimator";
import {ForegroundAnimation} from "./foregroundanimation/ForegroundAnimation";
import {ImmortalFruitsNearWinView} from "./views/ImmortalFruitsNearWinView";
import {GambleTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GambleTransitionController";
import {ImmortalFruitsGambleBet} from "./gameround/zeroBet/ImmortalFruitsGambleBet";
import {ImmortalFruitsExitGambleTransitionController} from "./transitions/ImmortalFruitsExitGambleTransitionController";
import {ImmortalFruitsBetlinesView} from "./betline/ImmortalFruitsBetlinesView";
import {ImmortalFruitsTimelineReelsController} from "./reel/ImmortalFruitsTimelineReelsController";
import {BonusWheelIntroTransitionControllerWithView} from "./transitions/BonusWheelIntroTransitionControllerWithView";
import {ImmortalTextBetLineNumber} from "./betline/number/ImmortalTextBetLineNumber";
import {SoundManager} from "./resource/sound/SoundManager";
import {FeaturePrice} from "./server/data/FeaturePrice";
export class ImmortalFruitsGameModuleConfig implements IGameModuleConfig {

    public static instance:ImmortalFruitsGameModuleConfig = new ImmortalFruitsGameModuleConfig();
    private static gameTweakerTest:GameTweakerTest;
    private static background:ImmortalFruitsBackground;
    private static foregroundAnimation:ForegroundAnimation;
    private static betLinesView:BetLinesView;
    private static jackpot: Jackpot;
    public static countUpView: CountUpView;
    public static winTextView: WinTextView;
    public static nearWinView: ImmortalFruitsNearWinView;
    public static symWinAnims: ImmortalFruitsSymbolsWinAnimations;
    private static soundManager: SoundManager;
    public static featurePrice:FeaturePrice;
    GAME_CONFIG:IGameConfig = ImmortalFruitsGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = ImmortalFruitsSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = ImmortalFruitsFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = ImmortalFruitsGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new ImmortalFruitsServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new ImmortalFruitsParsedInitData(data, <ImmortalFruitsServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new ImmortalFruitsParsedGameData(data, <ImmortalFruitsServerDataParser>dataParser);
    };

    REEL_CONTROLLER:(reelId:number) => SpinReelController = reelId => {
        return new ImmortalFruitsReelController(reelId);
    };
    REELS?:() => Reels = ()=>{
        return new ImmortalFruitsTimelineReelsController();
    };
    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    // REEL_PART_ANIMATOR?:(reelId:number) => SpinReelPartAnimator; // Default new SpinReelPartAnimator.
     REEL_PART_ANIMATOR:(reelId:number) => ImmortalFruitsSpinReelPartAnimator = (reelId:number) => {
         return new ImmortalFruitsSpinReelPartAnimator(reelId);
     };
    // INTRO_VIEW:(onClickCallback:() => void) => ImmortalFruitView =
    //     (onClickCallback:() => void) => new ImmortalFruitView({
    //         layer : ImmortalFruitsGameConfig.instance.LAYERS.INTRO.name,
    //         onButtonClickCallback : onClickCallback,
    //         resourceGroup : ResourcesGroupName.INTRO,
    //         backgroundTextures : {
    //             desktop : {landscape : ImmortalFruitsGameAssets.INTRO_BACKGROUND},
    //         },
    //         featureIcons : {
    //             icons : [ IntroFeatureLogo.VOLATILITY_MEDIUM]
    //         }
    //     });

        REEL_PART_CREATOR: () => ReelPartCreator = () => {
            return new ReelPartCreator(
                (symName: string, reelId: number, state?: ISymbolStateConfig): ImmortalFruitsReelSymbol => {
                    return new ImmortalFruitsReelSymbol(symName, reelId, state);
                });
        };
    SYMBOL_STATE_CREATOR: () => ReelSymbolStateCreator = () => {
        return new ImmortalFruitsReelSymbolStateCreator();
    };
    ZERO_BETS: (() => ZeroBetController)[] = [

            () => {
                return new ImmortalFruitsZeroBetController();
            }
    ];

    GAME_MODE_TRANSITIONS?: (() => GameModeTransitionController)[] = [
        () => {
            return new BonusWheelIntroTransitionControllerWithView(
                GameMode.NORMAL,
                ImmortalFruitsGameMode.BONUS_WHEEL,
                new ImmortalFruitsbonusViewIntroView(StageManager.getLayer(ImmortalFruitsLayerConfig.INTRO.name))
            );
        },
        () => {
            return new BonusWheelIntroTransitionControllerWithView(
                ImmortalFruitsGameMode.GAMBLE,
                ImmortalFruitsGameMode.BONUS_WHEEL,
                new ImmortalFruitsbonusViewIntroView(StageManager.getLayer(ImmortalFruitsLayerConfig.INTRO.name))
            );
        },

        () => {
            return new ImmortalFruitsExitGambleTransitionController(
                ImmortalFruitsGameMode.GAMBLE,
                ImmortalFruitsGameMode.NORMAL
            );
        },
        () => {
            return new GambleTransitionController(
                ImmortalFruitsGameMode.NORMAL,
                ImmortalFruitsGameMode.GAMBLE
            );
        },
        () => {
            return new GambleTransitionController(
                ImmortalFruitsGameMode.GAMBLE,
                ImmortalFruitsGameMode.BONUS_WHEEL
            )
        },
        () => {
            //Will only happen if you won >0 in bonus.
            return new GameModeTransitionControllerWithView(
                ImmortalFruitsGameMode.BONUS_WHEEL,
                ImmortalFruitsGameMode.GAMBLE,
            new ImmortalFruitsbonusViewOutroView(StageManager.getLayer(ImmortalFruitsLayerConfig.INTRO.name))
            )
        },
        () => {
            //Will only happen if you won nothing in bonus.
            return new GameModeTransitionControllerWithView(
                ImmortalFruitsGameMode.BONUS_WHEEL,
                GameMode.NORMAL,
                new ImmortalFruitsbonusViewOutroView(StageManager.getLayer(ImmortalFruitsLayerConfig.INTRO.name))
            );
        },
    ];

    constructor() {
        if (ImmortalFruitsGameModuleConfig.instance) {
            throw new Error("ImmortalFruitsGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new BetLineWinIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };


    GAME_FEATURE_CREATOR:() => void = () => {
        ImmortalFruitsGameModuleConfig.soundManager = new SoundManager();
        ImmortalFruitsGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        ImmortalFruitsGameModuleConfig.jackpot = new Jackpot();
        ImmortalFruitsGameModuleConfig.countUpView = new CountUpView();
        ImmortalFruitsGameModuleConfig.winTextView = new WinTextView();
        ImmortalFruitsGameModuleConfig.background = new ImmortalFruitsBackground();
        ImmortalFruitsGameModuleConfig.foregroundAnimation = new ForegroundAnimation();
        ImmortalFruitsGameModuleConfig.symWinAnims = new ImmortalFruitsSymbolsWinAnimations();
        ImmortalFruitsGameModuleConfig.betLinesView = new ImmortalFruitsBetlinesView(
            {
                map : [
                        1,7,12, 20,24, 25,2, 8,11,13,15,19,
                         3,6, 10,14,16, 18,23,4,5,9,17,  // left
                        21, 22,  29,31,37, 44,48,50,
                         26,30, 32, 36,38,43,47, 28,    // left/right
                         33,  35, 39, 41,  45,42, 34, 40,27, 46, 49,// right

                ]
            },
            (index:number):ImmortalTextBetLineNumber => {
                return new ImmortalTextBetLineNumber(index,{
                    layer: GameConfig.instance.LAYERS.BET_LINES.name,
                    width: 25,
                    height: 25,
                    horizontalPadding :[0.5*GameConfig.instance.REEL_AREA_POS_X/2+4,0.5*GameConfig.instance.REEL_AREA_POS_X -1.5 ],
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y +15,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT-15))
                    ],
                    textStyleNormal : {
                        fontFamily : "Impact",
                        fontSize : 15,
                        fill : "#ffffff"
                    },
                    textStyleWin : {
                        fontFamily : "Impact",
                        fontSize : 20,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 1

                    },
                    freeSTextStyleNormal: {
                        fontFamily: "Impact",
                        fontSize: 23,
                        fill: "#D76478"
                    },
                    freeSTextStyleWin: {
                        fontFamily: "Impact",
                        fontSize: 23,
                        fill: "#FFDDD4",
                        padding: 4
                    },
                    textWinScale: 1
                } );
            },
            /*{
                    layer : ImmortalFruitsGameConfig.instance.LAYERS.BET_LINES.name,
                    width : 25,
                    height : 25,
                    horizontalPadding :[0.5*GameConfig.instance.REEL_AREA_POS_X/2+4,0.5*GameConfig.instance.REEL_AREA_POS_X -1.5 ],
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y +15,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT-15))
                    ],
                    textStyleNormal : {
                        fontFamily : "Impact",
                        fontSize : 15,
                        fill : "#ffffff"
                    },
                    textStyleWin : {
                        fontFamily : "Impact",
                        fontSize : 20,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 1

                    },
                    textWinScale : 1
                }*/
            (index:number, numberPosition:number[], betLineData:number[]):ImmortalFruitsPolyBetLine => {
                return new ImmortalFruitsPolyBetLine(index, numberPosition, betLineData, {
                    staticLineLayer : ImmortalFruitsGameConfig.instance.LAYERS.BET_LINES.name,
                    lineThickness : 8,
                    baseColor : 0x46D260,
                    dynamicColor : true,
                    dynamicColors : [ 0xff3399,
                        0xff3333,
                        0xfd8c19,
                        0xccffcc,
                        0xffff00,
                        0x00cc00,
                        0x00cc66,
                        0x00ccff,
                        0x227bff,
                        0xcc33ff],
                    styles : [
                        {
                            "lineWidth" : 8,
                            "color" : 0x1a7db,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 4,
                            "color" : 0x17E2D1,
                            "alpha" : 1
                        }

                    ],
                    numberOffsetX : -20,
                    pointOverlapVerticalOffset : 20
                });
            }
        );
        new ImmortalFruitsReelBackgroundView();

        ImmortalFruitsGameModuleConfig.featurePrice = new FeaturePrice();
        ImmortalFruitsGameModuleConfig.nearWinView =new ImmortalFruitsNearWinView();
    };
    GAME_ROUND_CONFIG: () => GameRoundConfig = () => {
        return {
            NORMAL: {
                idle: [

                ],
                idleLoop: [
                    new ImmortalFruitsBetLineWin(false),
                    new ImmortalIdleAnimationController()
                ],
                starting: [
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0)
                    ],
                stoppable: [
                    new ReelStop(0),
                    new ImmortalFruitsNearWin(1, 1),
                    new ReelStop(1),
                    new ImmortalFruitsNearWin(2, 1),
                    new ReelStop(2),
                    new ImmortalFruitsNearWin(3, 1),
                    new ReelStop(3),
                    new ImmortalFruitsNearWin(4, 3),
                    new ReelStop(4),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new InitialWin(),
                        new ImmortalFruitsBetLineWin(true),
                        new NormalWin(ImmortalFruitsGameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.normalWin[0], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[1], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            BONUS_WHEEL: {
                idle: [
                    new ZeroBet()
                ],
                idleLoop: [
                    new ImmortalFruitsBetLineWin(false)
                ],
                starting: [
                    new bonusWheelController()
                ],
                stoppable:  [
                   new ImmortalFruitsStoppablePresentation()
                ],
                skippable: [
                    [
                        new ImmortalFruitsWinPresentation(),
                    ],
                    [
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.normalWin[0], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[1], ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            GAMBLE: {
                idle: [
                    new ImmortalFruitsGambleBet()
                ],
                idleLoop: [
                    new ImmortalFruitsBetLineWin(false)
                ],
                starting: [
                   // new ImmortalFruitsGameRoundPresentation()
                ],
                stoppable: [],
                skippable: [
                    [
                       // new ImmortalFruitsGameRoundPresentation()
                    ]
                ]
            }
        }
    };

}